import React, { createContext, useContext, useEffect, useState } from 'react';
import signalRService from '../../services/signalr.service';
import authStore from '../../store/auth';

const SignalRContext = createContext({});

export const SignalRProvider = ({ children }) => {
  const [isConnected, setIsConnected] = useState(false);
  const [connectionId, setConnectionId] = useState(null);

  useEffect(() => {
    const initializeSignalR = async () => {
      if (!authStore.token) return;

      try {
        // localAccountId is the OID claim — the same value the backend uses as azure_object_id
        const userId = authStore.user?.localAccountId ?? null;
        await signalRService.initialize(userId);
        await signalRService.start();

        const state = signalRService.getConnectionState();
        setIsConnected(state.isConnected);
        setConnectionId(state.connectionId);

        signalRService.onReconnected(() => {
          const state = signalRService.getConnectionState();
          setIsConnected(true);
          setConnectionId(state.connectionId);
        });
        signalRService.onReconnecting(() => {
          setIsConnected(false);
        });
        signalRService.onClose(() => {
          setIsConnected(false);
          setConnectionId(null);
        });
      } catch (error) {
        console.error('Failed to initialize SignalR:', error);
      }
    };

    initializeSignalR();

    return () => {
      signalRService.stop();
    };
  }, [authStore.token]);

  const contextValue = {
    isConnected,
    connectionId,
    service: signalRService
  };

  return <SignalRContext.Provider value={contextValue}>{children}</SignalRContext.Provider>;
};

export const useSignalR = () => {
  const context = useContext(SignalRContext);

  if (!context) {
    throw new Error('useSignalR must be used within a SignalRProvider');
  }

  return context;
};

export default SignalRProvider;
